// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.network-error {
	display: grid;
	place-items: center;
	background: white;
	z-index: 10000;
	top: 0;
	left: 0;
	bottom: 0;
	right: 0;
}

.network-error button {
	border-radius: 8px;
	color: white;
	height: 38px;
	width: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/components/networkerror/networkerror.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,mBAAmB;CACnB,iBAAiB;CACjB,cAAc;CACd,MAAM;CACN,OAAO;CACP,SAAS;CACT,QAAQ;AACT;;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,YAAY;CACZ,YAAY;AACb","sourcesContent":[".network-error {\n\tdisplay: grid;\n\tplace-items: center;\n\tbackground: white;\n\tz-index: 10000;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n}\n\n.network-error button {\n\tborder-radius: 8px;\n\tcolor: white;\n\theight: 38px;\n\twidth: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
